module.exports = __webpack_public_path__ + "static/img/17b.d0f53ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/17b.jpg
// module id = /GDk
// module chunks = 0